









































































import { Component, Vue } from 'vue-property-decorator';
import gql from 'graphql-tag';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class Account extends Vue {
  public userQuery = gql`
    query User {
      user {
        id
        email
        username
        bowlingNickname
        performance {
          totalPoints
          spentPoints
          earnedPoints
          averagePointsPerGame
        }
      }
    }
  `;

  public logout() {
    this.$store.dispatch('auth/deleteAuthToken');
    this.$router.push('/');
    window.location.reload();
  }

  public onError() {
    this.$router.back();
  }
}
